import _extends from "@babel/runtime/helpers/extends";
import { i18n } from "@lingui/core";
import React, { useEffect } from 'react';
import { useField } from 'react-final-form';
import { useCarleadFieldChangedTracking } from '../hooks/useCarleadFieldChangedTracking';
import { BaseField } from './BaseField';
import { selectFieldRenderer } from './fieldRenderers';
import { useSyncValues } from './hooks';
import { useStateMachineForFields } from './hooks/useStateMachineForFields';
export function QuestionaireSelect(_ref) {
  let {
    name,
    label,
    answers,
    placeholder = i18n._(
    /*i18n*/
    {
      id: 'carleadCreation.form.placeholder.questionnaireField'
    }),
    mktSelector = {
      value: label,
      group: false
    },
    isHiddenField,
    onFieldEnabled,
    onChange,
    ...props
  } = _ref;
  const {
    isFieldEnabled,
    sendUserSelect,
    stateFieldClassNames
  } = useStateMachineForFields({
    name
  });
  const options = answers.map(_ref2 => {
    let {
      value,
      label
    } = _ref2;
    return {
      value,
      label
    };
  });
  const trackLeadFieldChanged = useCarleadFieldChangedTracking();
  const {
    input
  } = useField(name, {
    subscription: {
      value: true
    }
  }); // TODO: https://wkdauto.atlassian.net/browse/CFE-12353
  // remove the hardcoded checks and make this work in a more general way
  // at this point in time, there only two questions for carlead creation
  // questionnary, and they are the same for all funnels (including sell only)
  // but marketing is in a hurry and the proper implementation will take more time.

  useEffect(() => {
    if (name === 'SELLPOINT' && input.value === 'SELLPOINT_NOT_PLANNED') {
      trackLeadFieldChanged('SELL_TYPES', 'autofill');
    }
  }, [input.value, name, trackLeadFieldChanged]);
  useSyncValues(name);
  return /*#__PURE__*/React.createElement(BaseField, _extends({
    label: label,
    name: name,
    MktSelector: mktSelector,
    topContainerClassName: stateFieldClassNames,
    disabled: !isFieldEnabled,
    isHiddenField: isHiddenField,
    onFieldEnabled: onFieldEnabled,
    renderFieldComponent: _ref3 => {
      let {
        input,
        meta
      } = _ref3;
      return selectFieldRenderer({
        input,
        meta,
        placeholder,
        options,
        disabled: !isFieldEnabled,
        onChange: e => {
          onChange && onChange(e);
          sendUserSelect(e.target.value);
        }
      });
    }
  }, props));
}